var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 17,
    viewBox: "0 0 29 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.447739 15.9098C1.04473 16.4956 2.01264 16.4956 2.60963 15.9098L14.5 4.24251L26.3904 15.9098C26.9874 16.4956 27.9553 16.4956 28.5523 15.9098C29.1492 15.324 29.1492 14.3742 28.5523 13.7884L16.6619 2.1212L14.5 -0.000118895L12.3381 2.12118L0.44774 13.7885C-0.149248 14.3742 -0.14925 15.324 0.447739 15.9098Z",
    fill: "#FF1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperDropDownArrow);
export default __webpack_public_path__ + "static/media/UpperDropDownArrow.fa865013fff92d9eaf8da7fada69f3dd.svg";
export { ForwardRef as ReactComponent };